module.exports = __webpack_public_path__ + "assets/img/WinterStore_tit.91134ff8.png";